// extracted by mini-css-extract-plugin
export var lecture = "search-module--lecture--e28e4";
export var search = "search-module--search--b54ea";